// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RemoveBedOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 26 26","focusable":"false"},"children":[{"tag":"g","attrs":{"fill":"currentColor"},"children":[{"tag":"path","attrs":{"d":"M20 15v-4c1.1 0-2 0 0 0h-2v2H6v-3H4v10l.67 2h1l.67-2h11.33l.66 2h1l.67-2v-5zM6 15h12v3H6v-3zM22.66 2l-2.12 2.12L18.41 2 17 3.41l2.13 2.12-2.12 2.12 1.41 1.41 2.12-2.12 2.12 2.12 1.41-1.41-2.12-2.12 2.12-2.12L22.66 2z"}}]}]},"name":"remove_bed","theme":"outlined"};

const RemoveBedOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RemoveBedOutlinedSvg} />;
  RemoveBedOutlined.displayName = 'RemoveBedOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RemoveBedOutlined);
